import { ProductList } from '@components/organisms/ProductList';
import { ProductCardFragment } from '@sdk/gqlTypes/generatedOperations';
// import { PrismicRichText } from "@prismicio/react";
import * as React from 'react';
import { useIntl } from 'react-intl';

import * as S from './styles';

const OtherProducts: React.FC<{
  products: ProductCardFragment[];
}> = ({ products }) => {
  const intl = useIntl();

  if (products.length > 0) {
    return (
      <S.OtherProducts className="product-page__other-products">
        <S.OtherProductsWrapper>
          <S.OtherProductsTitle>
            <h2>
              {intl.formatMessage({
                defaultMessage: 'What others bought',
                id: 'pLFP9o',
              })}
            </h2>
          </S.OtherProductsTitle>
          <S.OtherProductsList>
            <ProductList innerList products={products} />
          </S.OtherProductsList>
        </S.OtherProductsWrapper>
      </S.OtherProducts>
    );
  }
  return null;
};

export default OtherProducts;
